import {
  AzureGroupInfoResponse,
  LessonNameAndType,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import { MappingState } from '../CourseMapping.enums';
import {
  CourseMapping,
  CourseMappingDisplayModel,
  ImportIssue,
  MappingsFilter,
} from '../CourseMapping.interfaces';

export const DEFAULT_FILTER: MappingsFilter = {
  filter: [
    MappingState.ManuallyMapped,
    MappingState.AutoMapped,
    MappingState.Unassigned,
  ],
  searchText: '',
};

export interface CourseMappingState {
  timetableCourses: LessonNameAndType[] | null;
  cloudCourses: AzureGroupInfoResponse[] | null;
  courseMappings: CourseMappingDisplayModel[] | null;
  initialMappings: CourseMapping[] | null;
  error: string | null;
  visibleItems: CourseMappingDisplayModel[] | null;
  mappingsFilter: MappingsFilter;
  page: number;
  maxPage: number;
  itemsPerPage: number;
  hasChanges: boolean;
  importIssues: ImportIssue[];
  /** See `CourseTimetableMappingComponentProps.allowMultipleAzureGroupUsage`. */
  allowMultipleAzureGroupUsage: boolean;
}

export const createInitialState = (): CourseMappingState => {
  return {
    courseMappings: null,
    initialMappings: null,
    timetableCourses: null,
    cloudCourses: null,
    error: null,
    visibleItems: null,
    mappingsFilter: DEFAULT_FILTER,
    page: 1,
    maxPage: 1,
    itemsPerPage: 50,
    hasChanges: false,
    importIssues: [],
    allowMultipleAzureGroupUsage: false,
  };
};
